import { BreakpointType } from '@interface/common';

export const MOBILE: BreakpointType = 'tablet';
export const TABLET: BreakpointType = 'mobile';
export const DESKTOP: BreakpointType = 'desktop';
export const WIDE: BreakpointType = 'wide';
export const ULTRA: BreakpointType = 'ultra';
